import { ClientType } from '../apollo'
import { SmartSubscribe, types } from '../types'
import { debug } from '@dinosband/dbi-utils'

import { onProfileUpdated } from './profile-gql'

type Callback = (newData: types.Profile) => void

export function subscribeOnProfileUpdated (client: ClientType, userId: number, profileIds: number[], cb: Callback): SmartSubscribe {
  const subscribe = client.subscribe({
    query: onProfileUpdated,
    variables: {
      profileIds,
    },
  })
  const subscription = subscribe.subscribe({
    next: ({ data }) => {
      const newData = data.onProfileUpdated as types.Profile
      debug.log('=> onProfileUpdated: name = ', newData.name)
      cb(newData)
    },
  })

  return new SmartSubscribe(subscribe, subscription)
}
